import { render, staticRenderFns } from "./pharmacy_items.vue?vue&type=template&id=2508f155&scoped=true&"
import script from "./pharmacy_items.vue?vue&type=script&lang=js&"
export * from "./pharmacy_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508f155",
  null
  
)

export default component.exports